export interface UserProfile {
    accountNonExpired: boolean;
    accountNonLocked: boolean;
    agency: {
      name: string;
      id: number;
    }
    applicationName: string;
    authorities: [{authority: string}],
    authorization: Authorization,
    authorizations: [Authorization]
    credentialsNonExpired: boolean,
    enabled: boolean,
    installationName: string,
    participantId: number,
    roleName: CiprsRole,
    user:
      {
        commonName: string,
        firstName: string
        id: number,
        lastName: string,
        middleName: string,
        special: boolean,
        status: string,
        title: string,
        userId: string
      }
    userId: string
  }

export interface Authorization {
      applicationId: number,
      applicationName: string,
      geoId: number,
      geoName: string,
      geoType: string,
      geoTypeId: number,
      id: number,
      installationId: number,
      installationName: string,
      roleId: number,
      roleName: string,
      status: string,
      user: number,
      userId: string
}

export enum CiprsRole {
    Public = 'PUBLIC',
    Defense_Attorney = 'DEFENSE ATTORNEY',
    District_Attorney = 'DISTRICT ATTORNEY',
    Public_Defender = 'PUBLIC DEFENDER'
};



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/user.ts